import { Image } from '../../../shared/shared.interface';

export interface Modal {
  state: ModalState;
}
export interface ModalState {
  hidden: boolean;
  label: string;
  isCheckBox?: boolean;
  buttons: ButtonState[];
  cssClass: string;
  checkboxText?: string;
  closeHidden?: boolean;
  tooltip?: {
		closeIcon: Image;
		content: string;
	};
}

export interface ButtonState {
  label: string;
  id?: string;
  iconPath?: string;
  cssClass: string;
  disabled: boolean;
  hidden?: boolean;
}

export interface ModalEvent {
  state: ModalState;
  cta: ButtonState;
}

export enum Icon {
  arrowLeft = 'assets/arrowleftOrange.svg',
  arrowLeftRaymond = 'assets/arrowleftOrangeRaymond.svg'
}

export enum ButtonLabel {
  editNewLocation = 'Edit New Location'
}

export interface NavButtonState {
    btnRequired: boolean;
    btnLabel: string;
}
